import { config, apiPath } from "@backstagex/core/src/config";
import dayjs from "dayjs";

const fields = [
  {
    type: "bsx-input",
    inputType: "text",
    label: "ID",
    model: "id",
    required: true,
    readonly: true,
    visible: (model) => model.id
  },
  {
    type: 'bsx-select',
    label: '院區選擇',
    model: 'branch_option',
    required: true,
    values() {
      return [
        { 'id': 'ALL', 'name': "全部" },
        { "id": 'CUSTOM', "name": "自訂" },
      ];
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-checklist',
    label: '院區',
    model: 'branch_id',
    required: true,  
    visible: (model) => model && model.branch_option == 'CUSTOM',
    style: 'matrix',
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/hospital-branch-list-checkbox', false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {      
      this.validation();
    },
  },
  {
    type: "bsx-datePicker",
    label: "開始日期  ",
    model: "begin_at",
    placeholder: "請選擇日期",
    required: true,
    hideClockIcon: true,
    //visible: (model) => model && model.visibility_rule == "BY_DATE",
    validator: function () {      
      this.validation();
    },
  },
  {
    type: "bsx-datePicker",
    label: "結束日期  ",
    model: "end_at",
    placeholder: "請選擇日期",
    required: true,
    hideClockIcon: true,
    //visible: (model) => model && model.visibility_rule == "BY_DATE",
    validator: function () {
      this.validation();

      let beginAt = dayjs(this.model.begin_at, "YYYY-MM-DD", true);
      let endAt = dayjs(this.model.end_at, "YYYY-MM-DD", true);

      if (beginAt.isValid() && endAt.isValid()) {
        if (!beginAt.isBefore(endAt) && this.model.begin_at != this.model.end_at) {
          this.inputError = true;
          this.errorMessage = "結束日期須等於或晚於開始日期";
        }
      }
    },
  },

];

export default fields;
